export default defineNuxtPlugin(() => {
    const hostname = window.location.hostname

    // 不同域名对应不同网站配置
    const siteMap: Record<string, { title: string; favicon: string }> = {
        'www.halonovel.com': {
            title: 'haloNovel',
            favicon: '/HaloNovel.jpg'
        },
        'www.noveliax.com': {
            title: 'novelIax',
            favicon: '/Noveliax.jpg'
        },
        'www.noveloria.com': {
            title: 'novelOria',
            favicon: '/Noveloria.jpg'
        },
        'www.novelessa.com': {
            title: 'novelEssa',
            favicon: '/Novelessa.jpg'
        },
        'www.noveldrift.com': {
            title: 'novelDrift',
            favicon: '/Noveldrift.jpg'
        },
        'www.noveluno.com': {
            title: 'novelUno',
            favicon: '/Noveluno.jpg'
        },
        'www.runenovel.com': {
            title: 'runeNovel',
            favicon: '/Runenovel.jpg'
        },
        'www.veranovel.com': {
            title: 'veraNovel',
            favicon: '/Veranovel.jpg'
        },
        'www.neonnovel.com': {
            title: 'neonNovel',
            favicon: '/Neonnovel.jpg'
        },
        'www.orbnovel.com': {
            title: 'orbNovel',
            favicon: '/Orbnovel.jpg'
        },
        'www.draconovel.com': {
            title: 'dracoNovel',
            favicon: '/Draconovel.jpg'
        },
        'www.solianovel.com': {
            title: 'soliaNovel',
            favicon: '/Solianovel.jpg'
        },
        'www.horizonnovel.com': {
            title: 'horizonNovel',
            favicon: '/Horizonnovel.jpg'
        },

        'www.velunovel.com': {
            title: 'Velunovel',
            favicon: '/Velunovel.jpg'
        },
        'www.lumovel.com': {
            title: 'Lumovel',
            favicon: '/Lumovel.jpg'
        },
        'www.veloranovel.com': {
            title: 'VeloraNovel',
            favicon: '/VeloraNovel.jpg'
        },
        'www.zyronovel.com': {
            title: 'Zyronovel',
            favicon: '/Zyronovel.jpg'
        },
        'www.novellurexa.com': {
            title: 'novellurexa',
            favicon: '/Novellurexa.jpg'
        },
        'www.mystovanovel.com': {
            title: 'MystovaNovel',
            favicon: '/MystovaNovel.jpg'
        },
        'www.avenovel.com': {
            title: 'Avenovel',
            favicon: '/Avenovel.jpg'
        },
        'www.elynovel.com': {
            title: 'Elynovel',
            favicon: '/Elynovel.jpg'
        },
        'www.elunovel.com': {
            title: 'Elunovel',
            favicon: '/Elunovel.jpg'
        },
        'www.virelnovel.com': {
            title: 'VirelNovel',
            favicon: '/VirelNovel.jpg'
        },
        'www.talevoranovel.com': {
            title: 'TalevoraNovel',
            favicon: '/TalevoraNovel.jpg'
        },
        'www.novelvirexa.com': {
            title: 'NovelVirexa',
            favicon: '/NovelVirexa.jpg'
        },
        'www.dreamvellenovel.com': {
            title: 'DreamvelleNovel',
            favicon: '/DreamvelleNovel.jpg'
        },
        'www.plotaranovel.com': {
            title: 'PlotaraNovel',
            favicon: '/PlotaraNovel.jpg'
        },


        'localhost': {
            title: 'orbNovel',
            favicon: '/Draconovel.jpg'
        },
        'default': {
            title: 'haloNovel',
            favicon: '/Veranovel.jpg'
        }
    }
    // 取对应配置
    const site = siteMap[hostname] || siteMap.default

    // 设置标题模板
    useHead({
        titleTemplate: (title) => title ? `${title} - ${site.title}` : site.title,
        link: [
            { rel: 'icon', type: 'image/jpeg', href: `${site.favicon}?v=1.0.0` }
        ]
    })
})
